
const s4 = () =>
  Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
String.GUID = function () {
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`.toLowerCase()
}
String.prototype.replaceAll = function (old_str, new_str) {
  return this.split(old_str).join(new_str)
}
Date.prototype.toString = function (format) {
  format = format || 'yyyy-MM-ddTHH:mm:ssZ'
  var MM = this.getMonth() + 1
  var dd = this.getDate()
  var yyyy = this.getFullYear()
  var HH = this.getHours()
  var mm = this.getMinutes()
  var ss = this.getSeconds()
  var T = -(this.getTimezoneOffset() / 60)
  var s = T < 0 ? '-' : '+'
  MM = MM < 10 ? '0' + MM : MM
  dd = dd < 10 ? '0' + dd : dd
  HH = HH < 10 ? '0' + HH : HH
  mm = mm < 10 ? '0' + mm : mm
  ss = ss === 0 ? '00' : ss < 10 ? '0' + ss : ss
  T = Math.abs(T)
  var Z = s + (T < 10 ? `0${T}:00` : `${T}:00`)
  var str = format
    .replaceAll('yyyy', yyyy)
    .replaceAll('MM', MM)
    .replaceAll('dd', dd)
    .replaceAll('HH', HH)
    .replaceAll('mm', mm)
    .replaceAll('ss', ss)
    .replaceAll('Z', Z)
  return str
}
Date.prototype.toUTCString = function (format) {
  format = format || 'yyyy-MM-ddTHH:mm:ssZ'
  var MM = this.getUTCMonth() + 1
  var dd = this.getUTCDate()
  var yyyy = this.getUTCFullYear()
  var HH = this.getUTCHours()
  var mm = this.getUTCMinutes()
  var ss = this.getUTCSeconds()
  MM = MM < 10 ? '0' + MM : MM
  dd = dd < 10 ? '0' + dd : dd
  HH = HH < 10 ? '0' + HH : HH
  mm = mm < 10 ? '0' + mm : mm
  ss = ss === 0 ? '00' : ss < 10 ? '0' + ss : ss
  var Z = '+00:00'
  var str = format
    .replaceAll('yyyy', yyyy)
    .replaceAll('MM', MM)
    .replaceAll('dd', dd)
    .replaceAll('HH', HH)
    .replaceAll('mm', mm)
    .replaceAll('ss', ss)
    .replaceAll('Z', Z)
  return str
}
Date.prototype.addDays = function (days) {
  this.setDate(this.getDate() + days)
  return this
}
Date.prototype.addYears = function (y) {
  this.setFullYear(this.getFullYear() + y)
  return this
}
Date.prototype.addHours = function (hours) {
  this.setHours(this.getHours() + hours)
  return this
}
Date.prototype.addMinutes = function (minutes) {
  this.setMinutes(this.getMinutes() + minutes)
  return this
}
Date.prototype.addMilliseconds = function (ms) {
  this.setMilliseconds(this.getMilliseconds() + ms)
  return this
}
Date.prototype.addMonths = function (m) {
  this.setMonth(this.getMonth() + m);
  return this;
}
Date.toDate = function (str) {
  const aux = str.split('T')
  const date = aux[0].split('-')
  const y = date[0]
  let M = date[1]
  const d = date[2]
  const time = aux.length > 1 ? aux[1].split(':') : []
  const H = time.length < 1 ? 0 : time[0]
  const m = time.length < 2 ? 0 : time[1]
  const s = time.length < 3 ? 0 : time[2]
  M = parseInt(M) - 1
  return new Date(y, M, d, H, m, s)
}
Date.today = function () {
  const date = new Date()
  date.setHours(0)
  date.setMinutes(0)
  date.setSeconds(0)
  date.setMilliseconds(0)
  return date
}
Number.prototype.withSeparator = function (separator, fixed) {
  var x = fixed >= 0 ? this.toFixed(fixed) : this.toString()
  if (this === eval(x)) x = this.toString()
  var pattern = /(-?\d+)(\d{3})/
  while (pattern.test(x)) x = x.replace(pattern, '$1' + separator + '$2')
  return x
}
String.prototype.truncate = function (length, separator) {
  if (this.length <= length) return this

  separator = separator || '...'

  var sepLen = separator.length,
    charsToShow = length - sepLen,
    frontChars = Math.ceil(charsToShow / 2),
    backChars = Math.floor(charsToShow / 2)

  return (
    this.substr(0, frontChars) +
    separator +
    this.substr(this.length - backChars)
  )
}
Array.prototype.max = function (func) {
  return Math.max.apply(Math, this.map(func))
}
Number.prototype.formatUnit = function (unit, separator, decimals) {
  separator = separator || ''
  decimals = decimals === null || decimals === undefined ? 1 : decimals
  switch (unit) {
    case 'bytes':
      if (this > 1099511627776) {
        return `${(this / 1099511627776).withSeparator(',', decimals)}${
          separator
          }TB`
      }
      if (this > 1073741824) {
        return `${(this / 1073741824).withSeparator(',', decimals)}${
          separator
          }GB`
      }
      if (this > 1048576) {
        return `${(this / 1048576).withSeparator(',', decimals)}${separator}MB`
      }
      if (this > 1024) {
        return `${(this / 1024).withSeparator(',', decimals)}${separator}KB`
      }
      return this
      break
    case 'count':
      if (this > 1000000000000) {
        return `${(this / 1000000000000).withSeparator(',', decimals)}${
          separator
          }T`
      }
      if (this > 1000000000) {
        return `${(this / 1000000000).withSeparator(',', decimals)}${
          separator
          }B`
      }
      if (this > 1000000) {
        return `${(this / 1000000).withSeparator(',', decimals)}${separator}M`
      }
      if (this > 1000) {
        return `${(this / 1000).withSeparator(',', decimals)}${separator}K`
      }
      return this.withSeparator(',', 0)
      break
    case 'ms':
      if (this > 86400000) {
        return `${(this / 86400000).withSeparator(',', decimals)}${separator}d`
      }
      if (this > 3600000) {
        return `${(this / 3600000).withSeparator(',', decimals)}${separator}hr`
      }
      if (this > 60000) {
        return `${(this / 60000).withSeparator(',', decimals)}${separator}min`
      }
      if (this > 1000) {
        return `${(this / 1000).withSeparator(',', decimals)}${separator}sec`
      }
      return `${this}${separator}ms`
      break
    case '%':
      return `${this}${separator}%`
      break
    default:
      return this
      break
  }
}
Number.prototype.toTimeString = function (format) {
  let current = this
  let days = Math.floor(current / 86400)
  current = current % 86400
  let hours = Math.floor(current / 3600)
  current = current % 3600
  let minutes = Math.floor(current / 60)
  current = current % 60
  let seconds = Math.floor(current)
  days = days === 0 ? '' : days < 10 ? `0${days}D ` : `${days}D `
  hours = hours < 10 ? `0${hours}` : `${hours}`
  minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
  seconds = seconds < 10 ? `0${seconds}` : `${seconds}`
  return format
    ? format
      .replaceAll('DD', days)
      .replaceAll('HH', hours)
      .replaceAll('mm', minutes)
      .replaceAll('ss', seconds)
    : `${days + hours}:${minutes}:${seconds}`
}
String.prototype.toTitleCase = function () {
  return this.replace(
    /\w\S*/g,
    txt =>
      txt.length > 1
        ? txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        : txt
  )
}


// WEBPACK FOOTER //
// ./src/libs/extensions.js